<nav class="sidebar">
  <ul class="sidebar-menu">
    @for (item of items; track $index) {
    <li
      [class.invalid]="isStepValid(item.id)"
      tabindex="0"
      (keydown.enter)="navigate(item.id)"
      class="menu-item"
      [class.active]="currentSection === item.id"
      (click)="navigate(item.id)"
      [class.disabled]="!canNavigateToStep(item.id)">
      <span>{{ item.label }}</span>
      <input
        type="radio"
        name="sidebar-radio"
        [value]="item.id"
        [checked]="currentSection === item.id"
        class="menu-radio" />
      @if (isStepDone(item.id)) {
        <img src="/svgs/check-icon.svg" alt="file" />
      } @else{
      <span class="custom-radio"></span>
      }
    </li>
    }
  </ul>
</nav>
